<table class="table mt-3" aria-label="assets-table">
    <thead class="bg-light">
        <tr>
            <ng-container *ngFor="let key of tableKeys">
                <th scope="col">{{ key.label }}</th>
            </ng-container>
        </tr>
    </thead>
    <tbody>
        <ng-container *ngFor="let item of assets; let i = index;">
            <tr>
                <ng-container *ngFor="let key of tableKeys">
                    @if (needPercentageBox(key.key)) {
                        <td class="fixed-width">
                            <input class="form-control"
                                [(ngModel)]="item[key.key]"
                                (blur)="formatPercentageAmount($event, item, key.key)"
                                [disabled]="checkIfDisabled(item, key.key)"
                            >
                        </td>
                    } @else if (key.key === 'amount') {
                        <td class="fixed-width">
                            <input class="form-control"
                                [(ngModel)]="item.amount"
                                (input)="refreshTotalAmount()"
                                (blur)="formatAssetAmount($event, item)"
                                [disabled]="checkIfDisabled(item, key.key)"
                                [ngClass]="{'is-invalid': maxAmountLimit(item)}"
                                >
                            <div *ngIf="maxAmountLimit(item)" class="invalid-feedback">
                                Il valore non può superare l'importo disponibile sul fondo
                            </div>
                        </td>
                    } @else if (key.key === 'percentage') {
                        <td>
                            <span>{{ formatValue(item[key.key]) }} %</span>
                        </td>
                    } @else {
                        <td>
                            <span>{{ item[key.key] }}</span>
                        </td>
                    }
                </ng-container>
            </tr>
        </ng-container>
    </tbody>
</table>
